module.exports = __webpack_public_path__ + "static/media/grid-item-a12.0d9829e4.png";